<div class="fill-height p-2">
  <mat-spinner *ngIf="isLoading"></mat-spinner>
  <mat-card>
    <mat-accordion multi="true" *ngIf="users.length > 0 && !isLoading">
      <mat-expansion-panel *ngFor="let user of users">
        <mat-expansion-panel-header>
          <span>User Email: <b>{{ user.email }}</b></span>
        </mat-expansion-panel-header>
        <div class="d-flex flex-column flex-sm-row gap-3 w-100">
          <div class="d-flex flex-column gap-3 col-12 col-sm-6">
            <div class="d-flex flex-column">
              <span *ngIf="user.printingService[0] || user.branch[0]"
                class="px-3 py-2 rounded-pill zx-border-gray-v-light">
                Last Visit: <b>{{ user.printingService[0] }}</b> - <b>{{ user.branch[0] }}</b>
              </span>
              <span *ngIf="!user.printingService[0] || !user.branch[0]"
                class="px-3 py-2 rounded-pill zx-border-gray-v-light">
                printing service and branch are not set
              </span>
              <span class="d-flex flex-column gap-1" *ngIf="user.printingService[1] || user.branch[1]">
                <u class="underline pt-2">Last Visits before:</u>
                <span *ngIf="user.printingService[1] || user.branch[1]" class="px-2 py-1">
                  <span>1 - {{ user.printingService[1] }}</span> - <span>{{ user.branch[1] }}</span>
                </span>
                <span *ngIf="user.printingService[2] || user.branch[2]" class="px-2 py-1">
                  <span>2 - {{ user.printingService[2] }}</span> - <span>{{ user.branch[2] }}</span>
                </span>
                <span *ngIf="user.printingService[3] || user.branch[3]" class="px-2 py-1">
                  <span>3 - {{ user.printingService[3] }}</span> - <span>{{ user.branch[3] }}</span>
                </span>
              </span>
            </div>
            <span class="px-3 py-2 rounded-pill zx-border-gray-v-light">
              {{ "Provider: " }} <b>{{ user.provider }}</b>
            </span>
            <span class="px-3 py-2 rounded-pill zx-border-gray-v-light fw-bold">
              Super User!
            </span>
            <span class="d-flex flex-column gap-1">
              <u class="underline pt-2">Brancg Maniger for:</u>
              <!-- <span *ngFor="let BMbranch of user.isBMBranches; let i = index" class="px-2 py-1">
                <span>{{ i + 1 }} - {{ BMbranch }}</span>
              </span> -->
            </span>
          </div>
        </div>
        <mat-action-row>
          <a mat-button color="primary" [routerLink]="['/useredit', user.id]">EDIT</a>
          <button mat-button color="warn" (click)="onDelete(user.id)">DELETE</button>
        </mat-action-row>
      </mat-expansion-panel>
    </mat-accordion>
    <p class="info-text mat-body-1" *ngIf="users.length <= 0 && !isLoading">No userss added yet!</p>
    <div class="spacer"></div>
  </mat-card>
</div>

<div class="p-2">
  <mat-paginator class="m-0" [length]="totalUsers" [pageSize]="usersPerPage" [pageSizeOptions]="pageSizeOptions"
    (page)="onChangedPage($event)" *ngIf="users.length > 0"></mat-paginator>
</div>